'use client';

import { Box, Typography, Stack, IconButton, Paper, Tooltip, Chip, Button } from '@mui/material';
import { useMediaBrowserV2 } from '@/app/features/shared/media-browser-v2/context/MediaBrowserV2Context';
import { Close, Clear } from '@mui/icons-material';
import { renderMedia } from '@/app/features/shared/media-browser/media-renderer';
import { mediaRefName } from '@/app/features/shared/__to_be_integrated/types/general/media/media-helper';

export default function MultiSelectView() {
    const { selectedMediaList, toggleSelection, clearSelection } = useMediaBrowserV2();

    if (selectedMediaList.length <= 1) {
        return null;
    }

    return (
        <Box className="p-4">
            <Stack direction="column" spacing={2} alignItems="center" justifyContent="space-between" className="mb-4">
                <Box className="flex items-center gap-2">
                    <Typography variant="subtitle1" fontWeight={600}>
                        Ausgewählte Medien
                    </Typography>
                    <Chip
                        label={selectedMediaList.length}
                        color="primary"
                        size="small"
                    />
                </Box>
            </Stack>

            <Stack spacing={1.5} className="max-h-[400px] overflow-auto">
                {selectedMediaList.map((media) => {
                    const id = 'documentId' in media ? media.documentId : media.id;
                    const name = mediaRefName(media);

                    return (
                        <Paper
                            key={id}
                            className="relative flex items-center gap-3 p-2"
                            sx={{
                                backgroundColor: 'background.paper',
                            }}
                        >
                            {/* Thumbnail */}
                            <Box
                                className="relative size-[60px] shrink-0 overflow-hidden rounded"
                                sx={{
                                    backgroundColor: 'background.default',
                                }}
                            >
                                {renderMedia(media)}
                            </Box>

                            {/* Name */}
                            <Typography
                                variant="body2"
                                className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap"
                            >
                                {name}
                            </Typography>

                            {/* Remove Button - always visible */}
                            <Tooltip title="Entfernen">
                                <IconButton
                                    size="small"
                                    onClick={() => toggleSelection(id)}
                                    color="error"
                                >
                                    <Close fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Paper>
                    );
                })}
                <Button
                    size="small"
                    variant="outlined"
                    color="error"
                    startIcon={<Clear />}
                    onClick={clearSelection}
                >
                    Alle entfernen
                </Button>
            </Stack>
        </Box>
    );
}
